<template>
  <div :class="'button__wrapper' + (editMode == 'editor' ? ' editor' : '')">
    <a href="/#/"
        v-on:dblclick="openSettings"
        style="text-decoration: none"
        class="call-settings__block"
        v-if="editMode == 'editor' && !migrated" v-show="pluginConfig.showSettingsLabel">
      <div class="call-settings__icn">
        <img src="../assets/img/rectangle-46.svg" alt>
      </div>
      <div class="call-settings__description">
        <span class="call-settings__description_f-line">{{ $t("button.callSettingsDescription") }}</span>
        <span class="call-settings__description_s-line">{{ $t("button.callSettingsDescriptionSmall") }}</span>
      </div>
    </a>
    <div class="button__block" :style="!migrated && editMode != 'editor' ? 'margin-top: 52px' : ''">
      <button :class="'button__block__item button__block__item_front btn__' + pluginConfig.buttonClass" @click="pay" v-bind:style="buttonStyle">
        <div>
          {{ pluginConfig.buttonText }}
          <img style="margin-left: 5px; vertical-align: middle;" src="../assets/img/paypal.svg" v-if="pluginConfig.paypal2 == 1" alt>
        </div>
      </button>
      <div class="button__block__icons">
        <div class="block__icons__item" v-if="pluginConfig.paypal == 1">
          <img src="../assets/img/paypal-light.svg" alt>
        </div>
        <div class="block__icons__item" v-if="pluginConfig.mc == 1">
          <img src="../assets/img/master-card-dark.svg" alt>
        </div>
        <div class="block__icons__item" v-if="pluginConfig.visa == 1">
          <img src="../assets/img/visa-dark.svg" alt>
        </div>
        <div class="block__icons__item" v-if="pluginConfig.dis == 1">
          <img src="../assets/img/discover-dark.svg" alt>
        </div>
        <div class="block__icons__item" v-if="pluginConfig.ae == 1">
          <img src="../assets/img/american-express-dark.svg" alt>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as GA from '@/assets/js/ga.js'
import * as Helpers from '@/assets/js/helpers.js'

export default {
  name: 'ButtonVcita',
  props: ['checkboxes'],
  data () {
    const _lm = this.$i18n
    return {
      pluginConfig: {
        ae: 1,
        visa: 1,
        mc: 1,
        paypal: 1,
        dis: 1,
        paypal2: 0,
        buttonText: _lm.t('designTab.buttonPayDefaultText'),
        wixColor: 1,
        fontFamily: 'SalesforceSans',
        fontSize: '15',
        textColor: '#384766',
        mainColor: '#ffc43a',
        mainColor2: '#fbbb03',
        borderColor: '#b58c00',
        shadowColor: '#00000080',
        borderSize: 1,
        borderRound: 16,
        buttonClass: 'default',
        showSettingsLabel: 1
      },
      pivotId: '',
      paymConfig: {
        currency: 'USD',
        product_price: '',
        product_name: ''
      },
      vcitaUid: null,
      userData: null,
      editMode: 'preview',
      apiURL: this.$dbapi,
      buttonStyle: {
        '--button-font-size': '15px',
        '--button-font-family': 'SalesforceSans',
        '--button-font-color': '#384766',
        '--button-border-radius': '16px',
        '--button-border-size': '1px',
        '--button-border-color': '#b58c00',
        '--button-background-color': '#ffc43a',
        '--button-background-color2': '#fbbb03',
        '--button-box-shadow-color': '#00000080'
      },
      migrated: 0
    }
  },
  methods: {
    getLanguage: async function () {},
    checkLocal: function () {
      const instanceId = this.getInstanceId()
      const dt = Helpers.parseJSON(localStorage.getItem(`vc_design_cfg_${instanceId}`))

      if (dt !== null) {
        for (let i in dt) {
          if (this.pluginConfig[i] !== undefined) this.pluginConfig[i] = dt[i]
        }

        this.buttonStyle['--button-font-size'] = this.pluginConfig.fontSize + 'px'
        this.buttonStyle['--button-font-family'] = this.pluginConfig.fontFamily
        this.buttonStyle['--button-font-color'] = this.pluginConfig.textColor
        this.buttonStyle['--button-border-radius'] = this.pluginConfig.borderRound + 'px'
        this.buttonStyle['--button-border-size'] = this.pluginConfig.borderSize + 'px'
        this.buttonStyle['--button-border-color'] = this.pluginConfig.borderColor
        this.buttonStyle['--button-background-color'] = this.pluginConfig.mainColor
        this.buttonStyle['--button-box-shadow-color'] = this.pluginConfig.shadowColor
        this.buttonStyle['--button-background-color2'] = this.pluginConfig.mainColor2
      }

      const pt = Helpers.parseJSON(localStorage.getItem(`vc_paym_cfg_${instanceId}`))

      if (pt !== null) {
        this.paymConfig.currency = pt.currency
        this.paymConfig.product_name = pt.product_name
        this.paymConfig.product_price = pt.product_price
        if (pt.square_location_id !== '' && pt.square_location_id !== null) this.paymConfig.currency = 'USD'
      }

      const ud = Helpers.parseJSON(localStorage.getItem(`vc_usr_data_${instanceId}`))
      this.userData = ud

      if (ud !== null && ud.business_id !== undefined) {
        this.vcitaUid = ud.business_id
      } else {
        this.vcitaUid = null
      }

      setTimeout(this.checkLocal, 500)
    },
    openSettings: function () {
      const settingsWin = window.open(`${window.location.origin}/settings`, '_blank', 'fullscreen=no,height=600,width=500')
      settingsWin.parent_window = window
      settingsWin._instanceId = Wix.Utils.getInstanceId() // eslint-disable-line
      settingsWin._compId = Wix.Utils.getCompId() // eslint-disable-line
      settingsWin.mixpanel = window.mixpanel
      window._instanceId = settingsWin._instanceId
      window._compId = settingsWin._compId
    },
    pay: function () {
      let href = ''

      if (this.vcitaUid !== null && this.vcitaUid !== undefined) {
        let cur = this.paymConfig.currency
        let amt = this.paymConfig.product_price
        let name = this.paymConfig.product_name
        if (name === undefined) name = ''
        if (amt === undefined) amt = ''
        if (cur === undefined || cur === null || cur === '') cur = 'USD'

        href = `https://clients.${this.$vcitaAddress}/portal/${this.vcitaUid}` +
          `#/pay?&s=wixpayments&amount=${amt}` +
          `&branding_id=&email=&external_origin=true&first_name=&last_name=&pay_for=${encodeURIComponent(name)}` +
          `&phone=&v_currency=${cur}&o=${window._siteBaseUrl}`
      }

      if (href.length > 0) {
        let w = 1300
        if (Wix.Utils.getDeviceType() !== 'desktop') w = 360 // eslint-disable-line
        Wix.openModal(href, w, 600, '', function () {}) // eslint-disable-line
      }
    },
    getInstanceId: function () { return this.$wixInstanceId },
    apiSyncComponentData: function (compId, instanceId) {
      const data = {
        compId: compId,
        instanceId: instanceId
      }

      const _this = this
      const url = `${this.apiURL}/checkinstall`

      axios
        .post(url, data)
        .then(function (response) {
          const data = Helpers.parseJSON(response.data)
          // console.log(data)

          if (data !== null && data.design_conf !== undefined) {
            _this.pivotId = data.pivot_id
            const d = Helpers.parseJSON(data.design_conf)
            // console.log(d)

            if (d !== null) {
              for (let i in d) {
                if (_this.paymConfig[i] !== undefined) {
                  _this.paymConfig[i] = d[i]
                }
              }

              localStorage.setItem(`vc_paym_cfg_${instanceId}`, JSON.stringify(_this.paymConfig))

              for (let i in d) {
                if (_this.pluginConfig[i] !== undefined) {
                  _this.pluginConfig[i] = d[i]
                }
              }

              if (_this.pluginConfig.buttonText !== undefined && _this.pluginConfig.buttonText === 'designTab.buttonPayDefault') {
                _this.pluginConfig.buttonText = _this.$i18n.t('designTab.buttonPayDefaultText')
              }

              localStorage.setItem(`vc_design_cfg_${instanceId}`, JSON.stringify(_this.pluginConfig))
            } else {
              localStorage.removeItem(`vc_design_cfg_${instanceId}`)
              localStorage.removeItem(`vc_paym_cfg_${instanceId}`)
            }
          } else {
            localStorage.removeItem(`vc_design_cfg_${instanceId}`)
            localStorage.removeItem(`vc_paym_cfg_${instanceId}`)
          }

          if (data !== null && data.migrated !== undefined) _this.migrated = data.migrated

          if (data !== null && data.business_id !== undefined && data.business_id !== null) {
            _this.vcitaUid = data.business_id
            _this.userData = data
            localStorage.setItem(`vc_usr_data_${instanceId}`, JSON.stringify({ business_id: data.business_id }))
            _this.syncPlanData()
          }

          if (data !== null && data.new_install) {
            GA.track('wixpay_added_button', {
              uid: data.business_id !== undefined ? data.business_id : null
            })

            GA.track('wixpay_new_instance', {
              uid: data.business_id !== undefined ? data.business_id : null
            })
          }
        })
        .catch(function (error) { console.log(error) })
    },
    syncPlanData: function () {
      if (this.vcitaUid === null || !this.vcitaUid) return
      this.statFunc()
      /*
      if (this.vcitaUid !== 'xfwg3fv1y72hpztr' && !this.$TEST_MODE) {
        // this should work only for hookshot account
        return
      }
      */

      const instanceId = this.getInstanceId()

      if (instanceId === null) {
        console.error(`plan not fetched, wrong instanceId ${instanceId}`)
        return
      }

      let time = localStorage.getItem(`vc_timestamp_${instanceId}`)
      if (time !== null) time = parseInt(time)

      if (time === null || isNaN(time) || new Date().getTime() - time > 1000 * 60 * 60 * 24) {
        localStorage.setItem(`vc_timestamp_${instanceId}`, new Date().getTime())

        // let planData = Helpers.parseJSON(localStorage.getItem(instanceId + '_plnd'))
        const url = `${this.apiURL}/get_plan/${instanceId}`
        const _this = this

        axios
          .get(url)
          .then(function (response) {
            const d = Helpers.parseJSON(response.data)
            if (_this.$TEST_MODE) console.log(d)

            if (d !== null && !d.error) {
              try {
                const integrations = d.data.business.integrations.plugins
                const il = integrations.length
                let plan = {}

                for (let k = 0; k > il; k++) {
                  if (integrations[k].external_id === instanceId) {
                    plan = integrations[k]
                    break
                  }
                }

                if (_this.$TEST_MODE || _this.vcitaUid === 'xfwg3fv1y72hpztr') {
                  console.log(plan)
                  console.log(_this.$instanceData)
                }

                if (_this.$instanceData) {
                  const prodId = _this.$instanceData.vendorProductId
                  let wixPlan = typeof prodId === 'string' ? prodId.toLowerCase().trim() : 'free'
                  const vcitaPlan = plan.plan_name ? plan.plan_name.toLowerCase().trim() : wixPlan
                  let newPlan = null

                  if (wixPlan === 'free' && (vcitaPlan === null || vcitaPlan === 'trial' || vcitaPlan.indexOf('free') === 0)) {
                    _this.premiumFlag = false
                  }

                  if (vcitaPlan !== null && wixPlan !== null && vcitaPlan !== wixPlan) {
                    if (wixPlan === 'free') {
                      if (vcitaPlan === 'free payments' || vcitaPlan === 'online payments' || vcitaPlan === 'essentials') {
                        newPlan = 'trial'
                      }
                    } else if (wixPlan === 'essentials') {
                      if (vcitaPlan === 'trial' || vcitaPlan === 'free payments' || vcitaPlan === 'online payments') {
                        newPlan = 'plugins_ultimate'
                      }
                    } else if (wixPlan === 'invoicing') {
                      if (vcitaPlan === 'free payments' || vcitaPlan === 'essentials' || vcitaPlan === 'online payments' || vcitaPlan === 'trial') {
                        newPlan = 'invoicing'
                      }
                    } else if (wixPlan === 'payments') {
                      if (vcitaPlan === 'free payments' || vcitaPlan === 'essentials' || vcitaPlan === 'online payments' || vcitaPlan === 'trial') {
                        newPlan = 'online_payments'
                      }
                    }
                  } else if (vcitaPlan === wixPlan) {
                    if (wixPlan === 'free') {
                      newPlan = 'trial'
                    } else if (wixPlan === 'essentials') {
                      newPlan = 'plugins_ultimate'
                    } else if (wixPlan === 'invoicing') {
                      newPlan = 'invoicing'
                    } else if (wixPlan === 'payments') {
                      newPlan = 'online_payments'
                    }
                  }

                  if (newPlan === 'trial') _this.premiumFlag = false

                  if (_this.$TEST_MODE || _this.vcitaUid === 'xfwg3fv1y72hpztr') {
                    console.log(`vCita plan: ${vcitaPlan}\nWix plan: ${wixPlan}\nTarget plan ID: ${newPlan}`)
                  }
                  // if (_this.$TEST_MODE) newPlan = 'free_payments'

                  if (newPlan !== null) {
                    axios.get(`${_this.apiURL}/upd_plan/${instanceId}/${newPlan}`)
                      .then((resp1) => {
                        if (_this.$TEST_MODE || _this.vcitaUid === 'xfwg3fv1y72hpztr') {
                          console.log(resp1.data)
                        }
                      })
                  }
                }
              } catch (e) { console.log(e) }
            } else if (_this.$TEST_MODE) {
              console.log(d)
            }
          }).catch(function (error) { console.log(error) })
      }
    },
    statFunc: function () {
      if (this.$TEST_MODE) return
      const instanceId = this.getInstanceId()

      if (instanceId === null) {
        console.error(`stat not updated, wrong instanceId ${instanceId}`)
        return
      }

      if (!this.$instanceData) return

      const data = {
        business_id: this.vcitaUid,
        plan_name: this.$instanceData.vendorProductId,
        instance: this.$instanceData
      }

      const _this = this

      axios.post(`${_this.apiURL}/premium_stat/${instanceId}`, { data: data })
        .then((resp1) => {
          if (_this.$TEST_MODE || _this.userData.business_id === 'xfwg3fv1y72hpztr') {
            console.log(resp1.data)
          }
        })
    },
    apiSyncPaymentConfig: function () {
      const instanceId = this.getInstanceId()

      if (instanceId === null) {
        console.error(`config not syncronized, wrong instanceId ${instanceId}`)
        return
      }

      const url = `${this.apiURL}/sync_cfg/${instanceId}`
      const _this = this

      axios
        .get(url)
        .then(function (response) {
          const d = Helpers.parseJSON(response.data)

          if (d !== null) {
            for (let i in d) _this.paymConfig[i] = d[i]
            localStorage.setItem(`vc_paym_cfg_${instanceId}`, JSON.stringify(_this.paymConfig))
          }
        })
        .catch(function (error) { console.log(error) })
    },
    getCookieByName: function (name) {
      let value = `; ${document.cookie}`
      let parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop().split(';').shift()
    },
    genString: function (length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length

      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }

      return result
    }
  },
  created () {
    const _this = this

    if (typeof Wix !== 'undefined') {
      this.editMode = Wix.Utils.getViewMode() // eslint-disable-line

      Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, function (event) { // eslint-disable-line
        _this.editMode = event.editMode
      })

      Wix.addEventListener(Wix.Events.COMPONENT_DELETED, function (event) { // eslint-disable-line
        GA.track('wix_remove_button', { uid: _this.vcitaUid })
        const instanceId = _this.getInstanceId()

        if (instanceId === null) {
          console.error(`config not deleted, wrong instanceId ${instanceId}`)
          return
        }

        axios.get(`${_this.apiURL}/upd_plan/${instanceId}/trial`)
          .then((resp1) => {
            if (_this.$TEST_MODE) console.log(resp1.data)
          })

        const url = `${_this.apiURL}/del_cfg/${instanceId}`
        localStorage.removeItem(`vc_paym_cfg_${instanceId}`)
        localStorage.removeItem(`btn__reset_${instanceId}`)
        localStorage.removeItem(`vc_design_cfg_${instanceId}`)
        localStorage.removeItem(`vcita_cid_${instanceId}`)
        localStorage.removeItem(`vc_usr_data_${instanceId}`)

        axios
          .get(url)
          .then((response) => {}).catch((error) => { console.log(error.response) })
      })

      const instanceId = Wix.Utils.getInstanceId() // eslint-disable-line
      // console.log('current instance id is ' + instanceId)
      // console.log('current site owner id is ' + Wix.Utils.getSiteOwnerId())

      const compId = Wix.Utils.getCompId() // eslint-disable-line
      localStorage.setItem(`wix_coid_${instanceId}`, compId)
      _this.apiSyncComponentData(compId, instanceId)
      _this.apiSyncPaymentConfig()
      _this.checkLocal()
    }

    GA.init()

    let inter2 = setTimeout(function () {
      if (typeof mixpanel !== 'undefined' && typeof mixpanel.init === 'function') {  // eslint-disable-line
        clearInterval(inter2)
        mixpanel.init(_this.$mixpanelToken)  // eslint-disable-line

        mixpanel.register({  // eslint-disable-line
          'plugin': 'Integrations::WixPaymentsInstance',
          'wix_instance_id': _this.getInstanceId()
        })
      }
    }, 100)

    const instanceId = this.getInstanceId()
    const cookieSet = this.getCookieByName(`${instanceId}_vcita_usr_token`)

    if (cookieSet === undefined) {
      const token = this.genString(32)
      document.cookie = `${instanceId}_vcita_usr_token=${token}; expires=Fri, 31 Dec 9999 23:59:59 GMT`
      const url = `${this.apiURL}/stat/${instanceId}`
      const dt = { token: token }

      Wix.getSiteInfo(function (siteInfo) { // eslint-disable-line
        window._siteBaseUrl = siteInfo.baseUrl
        dt.site_url = siteInfo.baseUrl

        axios.post(url, { data: dt })
          .then((response) => {})
          .catch((error) => { console.log(error) })
      })
    } else {
      Wix.getSiteInfo((siteInfo) => { window._siteBaseUrl = siteInfo.baseUrl }) // eslint-disable-line
    }
  },
  mounted () {
    if (typeof Wix !== 'undefined') {
      const _this = this

      if (_this.editMode === 'editor') {
        let int

        const resize = function () {
          if (window.innerWidth < 200) Wix.resizeComponent({ width: 200 }) // eslint-disable-line
          if (window.innerHeight < 110) Wix.resizeComponent({ height: 110 }) // eslint-disable-line
        }

        window.addEventListener('resize', () => {
          clearTimeout(int)
          int = setTimeout(resize, 300)
        })

        setInterval(function () {
          const reset = localStorage.getItem(`btn__reset_${_this.getInstanceId()}`)

          if (reset !== null && reset) {
            localStorage.removeItem(`btn__reset_${_this.getInstanceId()}`)
            Wix.resizeComponent({ width: 250, height: 144 }) // eslint-disable-line
          }
        }, 100)

        document.querySelector('.button__wrapper').classList.add('editor')
      } else {
        document.querySelector('.button__wrapper').classList.remove('editor')
      }
    }
  }
}
</script>
<style lang="scss">
@import "../assets/style/_button.scss";
</style>
